import ProtectedRoute from './protectedRoute';
import Unauthorized from 'src/authentications/Unauthorized';
import Dashboard from 'src/pages/Dashboard';
import NewApplicationRedirectHandler from './ApplicationRedirectHandlers/NewApplicationRedirectHandler';
import ApplicationListRedirectHandler from './ApplicationRedirectHandlers/ApplicationListRedirectHandler';
import DraftApplicationsRedirectHandler from './ApplicationRedirectHandlers/DraftApplicationRedirectHandler';
import EditApplicationsRedirectHandler from './ApplicationRedirectHandlers/EditApplicationsRedirectHandler';
import UserProfile from 'src/pages/Users/Profile';
import AccountSettings from 'src/pages/Admin/AccountSettings';
import TownshipConfigurationRoute from './TownshipConfigurationRoute';
import UserManagementRoute from './UserManagementRoute';
import TownshipManagement from 'src/pages/SuperAdmin/TownshipManagement';
import PermitManagement from 'src/pages/SuperAdmin/PermitManagement';
import DepartmentManagement from 'src/pages/SuperAdmin/DepartmentManagement';
import PaymentMethods from 'src/pages/Payment/PaymentComponents/PaymentMethods';
import PetLicensePaymentAcknowledgement from 'src/pages/Payment/PetLicensePaymentAcknowledgement';
import ViewApplication from 'src/ui-component/ViewApplication';
import MyPets from 'src/pages/Permits/PetPermit/MyPets';
import PetDetail from 'src/pages/Permits/PetPermit/PetDetail';
import ReportRoute from './ReportRoute';
import PermitCloseOutRoute from './PermitCloseOutRoute';
import InspectionScheduleRoute from './InspectionScheduleRoute';
import SubscriptionRoute from './SubscriptionRoute';
import SuperAdminRoute from './SuperAdminRoute';
import RedirectUserToDashboard from './ApplicationRedirectHandlers/RedirectUserToDashboard';

export const privateRoutes = [
  {
    path: '/unauthorized',
    element: <Unauthorized />
  },
  {
    path: '/',
    element: <Dashboard />
  },
  {
    path: '/dashboard/:townshipId',
    element: <RedirectUserToDashboard />
  },
  {
    path: '/subscriptions',
    element: <SubscriptionRoute />
  },
  {
    path: '/users/:townshipId',
    element: <UserManagementRoute />
  },

  //Super Admin Routes
  {
    path: '/township-management/:townshipId',
    element: <SuperAdminRoute element={<TownshipManagement />} />
  },
  {
    path: '/department-management/:townshipId',
    element: <SuperAdminRoute element={<DepartmentManagement />} />
  },
  {
    path: '/permit-management/:townshipId',
    element: <SuperAdminRoute element={<PermitManagement />} />
  },

  {
    path: '/:townshipId/:department/:permit/application-list',
    element: (
      <ProtectedRoute
        allowedRoles={['']}
        element={<ApplicationListRedirectHandler />}
      />
    )
  },
  {
    path: '/:townshipId/:department/:permit/new-application',
    element: (
      <ProtectedRoute
        allowedRoles={['']}
        element={<NewApplicationRedirectHandler />}
      />
    )
  },
  {
    path: '/:townshipId/:department/:permit/draft-application',
    element: (
      <ProtectedRoute
        allowedRoles={['']}
        element={<DraftApplicationsRedirectHandler />}
      />
    )
  },
  {
    path: '/:townshipId/:department/:permit/report',
    element: <ReportRoute />
  },
  {
    path: '/:townshipId/:department/:permit/view-application/:applicationID',
    element: (
      <ProtectedRoute allowedRoles={['']} element={<ViewApplication />} />
    )
  },

  {
    path: '/:townshipId/:department/:permit/pet-details/:petId',
    element: <ProtectedRoute allowedRoles={['']} element={<PetDetail />} />
  },
  {
    path: '/:townshipId/:department/:permit/edit-application/:applicationID',
    element: (
      <ProtectedRoute
        allowedRoles={['']}
        element={<EditApplicationsRedirectHandler />}
      />
    )
  },
  {
    path: '/:townshipId/:department/:permit/close-out',
    element: <PermitCloseOutRoute />
  },
  {
    path: '/:townshipId/:department/:permit/inspection-schedule',
    element: <InspectionScheduleRoute />
  },
  {
    path: '/payment-methods',
    element: <ProtectedRoute allowedRoles={['']} element={<PaymentMethods />} />
  },
  {
    path: '/pet-license-payment-acknowledgement',
    element: (
      <ProtectedRoute
        allowedRoles={['']}
        element={<PetLicensePaymentAcknowledgement />}
      />
    )
  },
  {
    path: '/user-profile/:townshipId',
    element: <UserProfile />
  },
  {
    path: '/account-settings/:townshipId',
    element: <AccountSettings />
  },
  {
    path: '/township-configuration/:townshipId',
    element: <TownshipConfigurationRoute />
  },
  {
    path: '/:townshipId/:department/:permit/my-pets',
    element: <ProtectedRoute allowedRoles={['']} element={<MyPets />} />
  }
];
